/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hazy_Faint_Otter_PauseInputs */

const fr_hazy_faint_otter_pause = /** @type {(inputs: Hazy_Faint_Otter_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas encore accès à un groupe d'événements. Contactez l'équipe de votre box pour activer votre accès.`)
};

/**

* @param {Hazy_Faint_Otter_PauseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hazy_faint_otter_pause = /** @type {((inputs?: Hazy_Faint_Otter_PauseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hazy_Faint_Otter_PauseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hazy_faint_otter_pause(inputs)
});